import Vue from 'vue';
import Vuex from 'vuex';
import i18next from 'i18next';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: 'th',
    stream: null,
    chartInterval: 140,
    currentData: {
      videoBitrate: {
        max: 0,
        avg: 0,
        min: 0,
      },
      audioBitrate: {
        max: 0,
        avg: 0,
        min: 0,
      },
    },
  },
  getters: {
    videoBitrateObject(state) {
      if (state.stream) {
        return state.stream.source.video.bitrates;
      }
      return null;
    },
    audioBitrateObject(state) {
      if (state.stream) {
        return state.stream.source.audio.bitrates;
      }
      return null;
    },
  },
  mutations: {
    setChartInterval(state, number) {
      state.chartInterval = number;
    },
    setCurrentData(state, object) {
      state.currentData = object;
    },
    setLanguage(state, language) {
      state.language = language;
      i18next.changeLanguage(language);
    },
    setStream(state, stream) {
      state.stream = stream;
    },
  },
  actions: {
    setChartInterval({ commit }, number) {
      commit('setChartInterval', number);
    },
    setCurrentData({ commit }, object) {
      commit('setCurrentData', object);
    },
    setLanguage({ commit }, language) {
      commit('setLanguage', language);
    },
    setStream({ commit }, stream) {
      commit('setStream', stream);
    },
  },
  modules: {
  },
});
